export enum FamilyCodes {
  CoatedIndustry = 'CEE',
  BitumeModifyIndustry = 'FBM',
  EmulsionIndustry = 'FDE',
  DefaultTransportationFamily = 'ACH',
  DefaultCombustibleFamily = 'CBL',
  CoatedAggregate = 'COA',
  RoadTransportCode = 'ROU',
  OutgoingProducts = 'PS',
  DRC = 'DRC',
  MR = 'MR',
  DefaultDieselEnergy = 'DIE',
  DefaultDieselEnergyIntl = 'DIESEL'
}
